import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("wishlist", "* , product:product_id(*), user:user_id(user_name, id)");

export const wishlistApi = createApi({
  reducerPath: "wishListDetails",
  baseQuery: requestBaseQuery,
  tagTypes: ["wishlist"],
  endpoints: (builder) => ({
    addItemtoWishlist: builder.mutation({
      query: (details) => ({ type: "POST", data: details }),
      invalidatesTags: [{ type: "wishlist", id: "LIST" }],
    }),
    getWishListItems: builder.query({
      query: ({ filter }) => ({
        type: "GET",
        filters: filter ?? undefined,
      }),
      providesTags: () => [{ type: "wishlist", id: "LIST" }],
    }),
    softDeleteItem: builder.mutation({
      query: (id) => ({ type: "SOFT_DELETE", id }),
      invalidatesTags: [{ type: "wishlist", id: "LIST" }],
    }),
  }),
});

export const {
  useAddItemtoWishlistMutation,
  useGetWishListItemsQuery,
  useSoftDeleteItemMutation,
} = wishlistApi;
